import AdminFax from './admin-fax-component';
import AdminFaxDocumentTypeFilter from './admin-fax-document-filter';
import AdminFaxSearchModule from './admin-fax-search/admin-fax-search-module';
import AdminFaxResultsModule from './admin-fax-search-results/admin-fax-search-results-module';
import AdminFaxDetailsModule from './admin-fax-details/admin-fax-details-module';

const MODULE_NAME = 'App.admin.fax';
const module = angular
    .module(MODULE_NAME, [
        AdminFaxSearchModule,
        AdminFaxResultsModule,
        AdminFaxDetailsModule,
    ])
    .directive('ktAdminFax', AdminFax)
    .filter('faxDocumentType', AdminFaxDocumentTypeFilter);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin-fax/admin-fax-module.js